module.exports = __webpack_public_path__ + "img/tingzhi.a5c09b62.png";